import { BaseService } from "services/_baseService";

class TrainsAdminService extends BaseService<any> {
  constructor() {
    super(`trains`);
  }
}

export default new TrainsAdminService();
